'use client';

import 'lightgallery.js/dist/css/lightgallery.css'; //Added by Aarif
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';
import { LightgalleryItem, LightgalleryProvider } from 'react-lightgallery';

import { Img } from '@/components/common/ui/images/Img';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import { theme } from '@/components/features/theme/theme';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';

const CaseStudySingle = ({
	title,
	link,
	imageList,
	img,
	color,
	noPara,
	subColor,
	hover,
}) => {
	const PhotoItem = ({ image, group, noPara, title }) => {
		const plainTitle = typeof title === 'string' ? title.replace(/<[^>]*>/g, '') : '';
		return (
		<LightgalleryItem group={group} src={image}>
			{noPara ? (
				<Img parallax src={image} alt={plainTitle} />
			) : (
				<ImgParallax
					parallax
					src={image}
					alt={plainTitle}
				/>
			)}
			{thumbImge?.full_path && (
				<div className="hover-content">
					<img
						src={thumbImge?.full_path || '/images/static/blur.jpg'}
					/>
				</div>
			)}
		</LightgalleryItem>
	);
	};
	const dispatch = DispatchCursor();
	const bannerImge = imageList?.find(f => f?.banner === 'on');
	const thumbImge = imageList?.find(f => f?.thumb === 'on');

	return (
		<StyledCaseStudySingle
			onMouseEnter={() => CURSOR_TEXT(dispatch, 'View')}
			onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')}
			color={color}
			subColor={subColor}
			className="case-study-single ">
			<LightgalleryProvider
				lightgallerySettings={{
					download: false,
				}}>
				<div className="case-study-single__inner">
					{link && (
						<Link
							prefetch={true}
							href={link || '/blog/slug'}></Link>
					)}
					<div className="global-image-image">
						<PhotoItem
							title={title}
							group={'group'}
							image={img || bannerImge?.full_path}
							noPara={noPara}
						/>
					</div>

					<div className="case-study-single__inner__content">
						<h6>{title}</h6>
					</div>
				</div>
			</LightgalleryProvider>
		</StyledCaseStudySingle>
	);
};

const StyledCaseStudySingle = styled.div`
	//width: 100%;

	.case-study-single__inner {
		position: relative;
		overflow: hidden;
		cursor: pointer;
		border-radius: 5px;

		.small-text {
			font-weight: 500;
			font-size: 1rem; /* 16px */
			line-height: 1.5rem; /* 24px */
			letter-spacing: 0;
			color: ${props => props.subColor || 'rgba(21, 38, 55, 0.5)'};
		}

		.flipper {
			-webkit-transition: 1.5s;
			-webkit-transform-style: preserve-3d;
			position: relative;
		}

		.global-image-image {
			transition: ${theme.transition};
			-webkit-transition: 1.5s;
			-webkit-transform-style: preserve-3d;
			border-radius: 5px;
			overflow: hidden;
			position: relative;

			.hover-content {
				position: absolute;
				inset: 0;
				height: 100%;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: rgba(21, 38, 55, 0.5);
				transition: ${theme.transition};
				opacity: 0;

				img {
					height: 120px;

					width: auto !important;
					max-width: unset !important;
					position: relative !important;
				}
			}

			.global-image {
				position: relative;
				height: auto;
			}

			img {
				transition: ${theme.transition};
				width: 100% !important;
				position: relative !important;
				height: auto !important;
			}
		}

		a {
			position: absolute;
			height: 100%;
			width: 100%;
			left: 0;
			top: 0;
			z-index: 3;
		}

		&__content {
			h6 {
				color: ${props => props.color || '#FFF'};
				font-size: 1.25rem; /* 20px converted to rem */
				font-style: normal;
				font-weight: 500;
				line-height: 1.75rem; /* 28px converted to rem */
				transition: ${theme.transition};
				transition-delay: 0.3s;
				margin-top: 20px;

				@media (min-width: 1336px) {
					width: 69%;
				}
			}
		}

		&__count {
			margin-top: 15px;
			margin-bottom: 15px;

			svg {
				width: 30px;

				path {
					transition: ${theme.transition};

					stroke: ${props => props.color || '#FFF'};
				}
			}

			p {
				transition: ${theme.transition};

				display: flex;
				align-items: center;
				gap: 15px;
				color: ${props => props.color || '#FFF'};
				font-size: 1rem; /* 16px converted to rem */
				font-style: normal;
				font-weight: 500;
				line-height: 1.5rem; /* 24px converted to rem */
			}
		}

		&:hover {
			.global-image-image {
				.hover-content {
					opacity: 1;
				}

				img {
					transform: scale(1.04);
				}
			}

			h6 {
				color: ${props => props.hover || theme.colors.hover};
			}

			svg {
				path {
					stroke: ${props => props.hover || theme.colors.hover};
				}
			}

			p {
				color: ${props => props.hover || theme.colors.hover};
			}
		}
	}
`;
export default CaseStudySingle;
